/* Quiesco cross-sell — één klik toevoegen aan de winkelwagen.
   Tier 1: Shopify Standard Actions (al gekoppeld aan de Horizon cart drawer).
   Tier 2: /cart/add.js + het standaard cart-event, zodat bubble en drawer meebewegen. */
(function () {
  if (window.__quiescoCrossSell) return;
  window.__quiescoCrossSell = true;

  var ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
  var CART_URL = ((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart') + '.js';

  function drawerTarget() {
    return document.querySelector('theme-drawer#cart-drawer') || document;
  }

  function viaActions(id, qty) {
    var a = window.Shopify && window.Shopify.actions;
    if (!a || typeof a.updateCart !== 'function') return null;
    try {
      return a.updateCart(
        { lines: [{ merchandiseId: String(id), quantity: qty }] },
        { event: { context: 'product' } }
      );
    } catch (e) {
      return null;
    }
  }

  function viaAjax(id, qty) {
    var sectionIds = Array.prototype.map
      .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
        return el.getAttribute('data-section-id');
      })
      .join(',');

    var resolveFn, rejectFn;
    var deferred = new Promise(function (res, rej) {
      resolveFn = res;
      rejectFn = rej;
    });

    var evt = new Event('shopify:cart:lines-update', { bubbles: true });
    evt.action = 'add';
    evt.context = 'product';
    evt.lines = [{ merchandiseId: String(id), quantity: qty }];
    evt.promise = deferred;
    drawerTarget().dispatchEvent(evt);

    var body = new FormData();
    body.append('id', String(id));
    body.append('quantity', String(qty));
    if (sectionIds) body.append('sections', sectionIds);

    return fetch(ADD_URL, {
      method: 'POST',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (added) {
        if (added.status) throw new Error(added.message || 'Toevoegen mislukt');
        return fetch(CART_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            resolveFn({
              cart: {
                id: cart.token,
                totalQuantity: cart.item_count,
                cost: {
                  totalAmount: { amount: String(cart.total_price / 100), currencyCode: cart.currency }
                },
                lines: (cart.items || []).map(function (i) {
                  return {
                    id: i.key,
                    quantity: i.quantity,
                    cost: {
                      totalAmount: {
                        amount: String(i.final_line_price / 100),
                        currencyCode: cart.currency
                      }
                    }
                  };
                }),
                discountCodes: cart.discount_codes || []
              },
              detail: {
                items: cart.items,
                itemCount: cart.item_count,
                sections: added.sections,
                source: 'quiesco-cross-sell',
                didError: false
              }
            });
            return cart;
          });
      })
      .catch(function (err) {
        rejectFn(err);
        throw err;
      });
  }

  function addToCart(id, qty) {
    return viaActions(id, qty) || viaAjax(id, qty);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-qx-add]') : null;
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('data-qx-busy')) return;

    var row = btn.closest('[data-qx-row]');
    var picker = row ? row.querySelector('[data-qx-variant]') : null;
    var id = picker && picker.value ? picker.value : btn.getAttribute('data-qx-add');
    if (!id) return;

    var label = btn.textContent;
    btn.setAttribute('data-qx-busy', '1');
    btn.textContent = 'Bezig…';

    Promise.resolve(addToCart(id, 1))
      .then(function () {
        btn.textContent = 'Toegevoegd';
        btn.classList.add('is-done');
      })
      .catch(function () {
        btn.textContent = 'Niet gelukt';
      })
      .then(function () {
        setTimeout(function () {
          btn.textContent = label;
          btn.classList.remove('is-done');
          btn.removeAttribute('data-qx-busy');
        }, 2400);
      });
  });
})();
